import { render, staticRenderFns } from "./OxUploader.vue?vue&type=template&id=8646bc0e&"
import script from "./OxUploader.vue?vue&type=script&lang=js&"
export * from "./OxUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports